import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=5b1c6e5e"
import script from "./Atendimentos.vue?vue&type=script&lang=ts"
export * from "./Atendimentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports